/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { t } from 'i18next';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';
import Template from './template-card';

function TemplateModal({ selected, open, setSelected, setOpen, refetch }) {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);
  const [titles, setTitles] = useState({
    c_name: '',
    p_name: '',
  });
  const sendNotification = useNotification();
  const handleClose = () => {
    setSelected({});
    setTitles({ c_name: '', p_name: '' });
    setOpen(false);
  };

  const onSave = async () => {
    if (
      titles?.c_name != selected?.c_name ||
      titles?.p_name != selected?.p_name
    ) {
      setIsLoading(true);
      try {
        const response = await axiosPrivate.post(
          `admin/object/cname/${selected?.id}`,
          JSON.stringify(titles),
          {
            headers: { 'Content-Type': 'application/json' },
          },
        );
        if (response.data && response.data.status) {
          refetch();
          setOpen(false);
          setIsLoading(false);
          setSelected({});
          sendNotification({
            msg: t('settings.sms.alerts.templateSuccess'),
            variant: 'success',
          });
        }
      } catch (error) {
        setIsLoading(false);
        sendNotification({
          msg: error?.response?.data?.message || error?.message,
          variant: 'error',
        });
      }
    }
  };

  const onChange = (text, name) => {
    setTitles((prv) => ({ ...prv, [name]: text }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      PaperProps={{ className: '!base-border !shadow-none' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-gray-100 !text-center !mb-2'
      >
        <span>
          {t('settings.contracts.modal.editContractTemplate', {
            value: selected?.name,
          })}
        </span>
      </DialogTitle>

      <DialogContent>
        <div className='p-3 pb-0 pt-0'>
          <div>
            <div>{t('common.fields.contractNumber')}</div>
            <Template
              onChange={(text) => onChange(text, 'c_name')}
              defaultText={selected?.c_name}
              open={open}
            />
          </div>
          <div className='pt-4'>
            <div>{t('common.fields.receiptNumber')}</div>
            <Template
              onChange={(text) => onChange(text, 'p_name')}
              defaultText={selected?.p_name}
              open={open}
            />
          </div>
          <div className='flex items-start mt-5 justify-end gap-2'>
            <Button
              variant='contained'
              color='warning'
              size='small'
              onClick={handleClose}
              disabled={isLoading}
            >
              {t('common.button.cancel')}
            </Button>
            <Button
              variant='contained'
              color='success'
              size='small'
              onClick={onSave}
              disabled={isLoading}
            >
              {t('common.button.save')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default memo(TemplateModal);
